import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import Slider from '@material-ui/core/Slider'
import Grid from "@material-ui/core/Grid";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#BB0000'
    }
  }
})



// 何番目の問題か表示
const QuestionCountComponet = (props) => {

  const { counter, total, changeQuestionId } = props

  const [sliderValue, setSliderValue] = useState(1)

  useEffect(() => {
    setSliderValue(counter)
  }, [counter])
  
  return (
    <MuiThemeProvider theme={theme} >
      <Grid container spacing={1} className="questionCount">
        <Grid item xs={12} >
          Question <span>{sliderValue}</span> of <span>{total}</span>
        </Grid>
        <Grid item xs={4} />
          <Slider 
            color='primary'
            min={1} max={total} value={sliderValue} 
            onChange={(_, value) => setSliderValue(value)}
            onChangeCommitted={(_, value) => changeQuestionId(value)}
          />
        <Grid item xs={4} >          
        </Grid>
      </Grid>
    </MuiThemeProvider>
  )
}

export default QuestionCountComponet;



// WEBPACK FOOTER //
// ./src/components/quiz/QuestionCount.js